import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Animations } from './../../Animations';

@Component({
  selector: 'card-header',
  templateUrl: './card-header.component.html',
  styleUrls: ['./card-header.component.scss'],
  animations: [
    Animations.ColorRedExitButton
  ]
})
export class CardHeaderComponent {

  @Input() label: string = 'TBD';
  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();

  isRed: boolean = false;

  constructor() {
   }

  onCloseBtnClick() {
    this.onClose.emit();
  }

  mousein(){
    this.isRed = true;
  }

  mouseout(){
    this.isRed = false;
  }
}
